<template>

<header id="main-header">
    <img :src="require('@/assets/logo.png')" id="logo">

  <div id="et-top-navigation">
    <ul id="top-menu" class="nav">
      <li v-for="item in menuData" :key="item.id" class="menu-item l1"
        :class="{ 'has-children': item.children, 'current-menu-item': item.active, 'open': openItems.has(item.id) }"
        @mouseenter="item.children && handleMouseEnter(item.id)"
        @mouseleave="item.children && handleMouseLeave(item.id)" @touchend="item.children && handleToggle(item.id)">
        <a v-bind="item.link ? { href: item.link } : {}">
          {{ item.text }}
          <v-icon icon="mdi-chevron-down" v-if="item.children" size="small" class="menu-icon"></v-icon>
        </a>

        <ul v-if="item.children" class="sub-menu l1">
          <li v-for="subItem in item.children" :key="subItem.id" class="menu-item l2"
            :class="{ 'has-children': subItem.children, 'open': openItems.has(subItem.id) }">
            <a v-bind="subItem.link ? { href: subItem.link } : {}">
              {{ subItem.text }}
              <v-icon icon="mdi-chevron-down" v-if="subItem.children" size="small" class="menu-icon"></v-icon>
            </a>

            <ul v-if="subItem.children" class="sub-menu l2">
              <li v-for="subSubItem in subItem.children" :key="subSubItem.id" class="menu-item"
                :class="{ 'has-children': subSubItem.children, 'open': openItems.has(subSubItem.id) }">
                <a v-bind="subSubItem.link ? { href: subSubItem.link } : {}">
                  {{ subSubItem.text }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>

    <form role="search" method="get" id="searchform" class="searchform" action="https://cbgcorp.com/">
      <div>
        <label class="screen-reader-text" for="searchtext">Search for:</label>
        <input type="text" value="" name="s" id="searchtext">
        <input type="submit" id="searchsubmit" value="Search">
      </div>
    </form>

    <div class="menu-info">
      <p class="menu-info__phone">
        <v-icon icon="mdi-phone" size="small"></v-icon>
        88612997
      </p>
      <address class="menu-info__address">
        <v-icon icon="mdi-map-marker-outline" size="small"></v-icon>
        <span class="menu-info__address-text">四川省成都市双流区新川路706号<br>
          创智广场C座5A04</span>
      </address>
    </div>
  </div> <!-- #et-top-navigation -->
</header> <!-- #main-header -->

<span class="et_pb_scroll_top" :class="{ 'et-hidden': !showScrollTop, 'et-visible': showScrollTop }" @click="scrollToTop">
  <v-icon icon="mdi-chevron-up" size="29px" color="white"></v-icon>
</span>

</template>

<script>
import { ref, onMounted, onBeforeUnmount } from "vue";

export default {
  name: 'HeaderView',

  props: {
    active: {
      type: String,
      default: "0"
    }
  },

  setup() {
    const showScrollTop = ref(false);

    const handleScroll = () => {
      // 获取滚动位置
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      showScrollTop.value = scrollTop > 800;
    };

    // ✅ 滚动到顶部
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // ✅ 挂载和卸载事件
    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", handleScroll);
    });

    return {
      showScrollTop,
      scrollToTop
    };
  },

  data: () => ({
    menuData: [
      {
        text: "首页",
        link: "./",
      },
      {
        text: "产品",
        link: "./p01",
        children: [
          { text: "自然伽马传感器", link: "./p01" },
          { text: "方位伽马传感器", link: "./p02" }
        ]
      },
      { text: "联系我们", link: "./contact" },
      // {
      //   text: "邮件",
      //   link: "./mailbox",
      // },
    ],

    openItems: new Set(),
  }),

  created() {
    this.generateIds(this.menuData);
    this.setActiveMenu(this.active);
  },

  methods: {
    generateIds(items, parentIndex = "") {
      items.forEach((item, index) => {
        item.id = parentIndex ? `${parentIndex}-${index}` : `${index}`;

        if(item.link) {
          item.link = process.env.VUE_APP_BASE_PATH + item.link;
        }

        if (item.children) {
          this.generateIds(item.children, item.id);
        }
      });
    },

    setActiveMenu(activeMenuId) {
      this.menuData.forEach(item => {
        this.activateMenu(item, activeMenuId);
      });
    },
    activateMenu(item, activeMenuId) {
      if (item.id === activeMenuId) {
        item.active = true;
        return true;
      } else if (item.children) {
        let activeInChildren = false;
        item.children.forEach(child => {
          if (this.activateMenu(child, activeMenuId)) {
            activeInChildren = true;
          }
        });

        if (activeInChildren) {
          item.active = true;
          return true;
        }
      }

      return false;
    },

    handleMouseEnter(id) {
      this.openItems.add(id);
    },

    handleMouseLeave(id) {
      this.openItems.delete(id);
    },

    handleToggle(id) {
      if (this.openItems.has(id)) {
        this.openItems.delete(id);
      } else {
        this.openItems.add(id);
      }
    }

  }
}
</script>
